
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/freeze-dried-raw-nuggets",
      function () {
        return require("private-next-pages/products/freeze-dried-raw-nuggets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/freeze-dried-raw-nuggets"])
      });
    }
  